<template>
	<div>
		<div class="bg-grey vh-100" id="listpotonganx">

			<!-- HEADER -->
			<div class="header-top bg-white showPageDenda">
				<div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
					<div class="header-top--left">
						<div class="header-item" @click="back">
							<img src="../../../assets/icons/back-blue.svg" alt="a">
						</div>
					</div>
					<div class="header-top--middle f-cont f-16 f-bold">Denda Karyawan</div>
					<div class="header-top--right" v-on:click="showSearchPage">
						<div class="header-item">
							<img src="../../../assets/icons/search.svg" alt="">
						</div>
					</div>
				</div>
			</div>

			<div class="header-top bg-white showPageSearch fix-header-top" style="transform: none; -webkit-transform: none">
				<div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
					<div class="header-top--left add-padding-default">
						<input class="inputSearch" id="inputSearchDenda" type="text" v-on:keyup="searchDendaKeyup"
						       v-model="searchDenda"
						       placeholder="Cari..">
					</div>
					<div class="header-top--right" v-on:click="closeSearchDenda">
						<div class="header-item">
							<img src="../../../assets/img/x2.svg" alt="">
						</div>
					</div>
				</div>
			</div>

			<div class="showSearchPageDenda">
				<!-- CONTENT -->
				<div class="content-wrapper main-page" v-if="listDendaSearch.length >= 0">
					<div class="Search-BOX mar-top-16 add-padding-default mar-bottom-16" id="textSearchDenda"></div>
					<!-- ITEMS -->
					<div class="p-x-20 p-y-16 w-limit">
						<!-- LIST ITEMS -->
						<div class="card-item-wrapper mar-bot-12" v-for="denda in listDendaSearch"
						     :key="denda.id" @click="validateAccess('fine.read') && detailDenda(denda.idkaryawan)">
							<div class="card-item" style="position: relative"
							     :id="'denda-search-'" data-toggle="dropdown"
							     aria-haspopup="true" aria-expanded="false">
								<div class="top-card m-d-4">
									<div class="f-16 f-semi"
									     v-html="searchHighlight(denda.nama_karyawan, searchDenda)"></div>
									<div class="card-chevron"></div>
								</div>
								<div class="f-14 f-c-midgrey">
									<img src="../../../assets/icons/file-text-grey.svg" alt="" height="14px" class="m-r-4">
									{{ denda.jumlah_denda }} Denda
									<span class="f-c-red" v-if="denda.jumlah_belum_lunas > 0">({{ denda.jumlah_belum_lunas }} Belum Lunas)</span>
								</div>
								<div class="f-14 f-c-midgrey">
									<img src="../../../assets/icons/clock-grey.svg" alt="" height="14px" class="m-r-4">
									Terakhir {{ denda.tanggal_terakhir_denda }}
								</div>
								<div class=" f-14 f-c-midgrey">
									<img src="../../../assets/icons/tag-grey.svg" alt="" height="14px" class="m-r-4">
									Total {{ denda.total_denda | currency }}
								</div>
							</div>
						</div>
						<div class="loadmoreSpinner" id="loadingSpinnerListDendaSearch" style="display: none">
							<center>
								<div class="sp sp-circle"></div>
							</center>
						</div>

					</div>
				</div>
			</div>

			<div class="showPageDenda">

				<!-- CONTENT -->
				<div class="content-wrapper main-page">

					<!-- IF EMPTY -->
					<div class="empty-state display-none">
						<div class="empty-state--icon"></div>
						<div class="f-16 f-bold">Belum ada denda karyawan</div>
						<div class="f-14 f-c-midgrey">Denda yang terdaftar akan tampil disini</div>
					</div>

					<!-- ITEMS -->
					<div class="p-x-20 p-y-16 w-limit">

						<div class="d-flex justify-content-between m-d-16">
							<div class="d-block">
								<div class="f-16 f-c-midgrey">Total {{ this.infoDenda.total_denda_keseluruhan }} Denda</div>
								<div class="f-12 f-c-midgrey">dari {{ this.infoDenda.total_karyawan }} karyawan</div>
							</div>

							<FilterSorting @filter="filter" :jenisFilter="'listDenda'" style="margin-top: -6px"/>
						</div>

						<!-- LIST ITEMS -->
						<div class="card-item-wrapper mar-bot-12" v-for="denda in listDenda" :key="denda.idkaryawan"
						     @click="validateAccess('fine.read') && detailDenda(denda.idkaryawan)">
							<div class="card-item" style="position: relative"
							     :id="'denda-'" data-toggle="dropdown"
							     aria-haspopup="true" aria-expanded="false">
								<div class="top-card m-d-4">
									<div class="f-16 f-semi">{{ denda.nama_karyawan }}</div>
									<div class="card-chevron"></div>
								</div>
								<div class="f-14 f-c-midgrey">
									<img src="../../../assets/icons/file-text-grey.svg" alt="" height="14px" class="m-r-4">
									{{ denda.jumlah_denda }} Denda
									<span class="f-c-red" v-if="denda.jumlah_belum_lunas > 0">({{ denda.jumlah_belum_lunas }} Belum Lunas)</span>
								</div>
								<div class="f-14 f-c-midgrey">
									<img src="../../../assets/icons/clock-grey.svg" alt="" height="14px" class="m-r-4">
									Terakhir {{ denda.tanggal_terakhir_denda }}
								</div>
								<div class=" f-14 f-c-midgrey">
									<img src="../../../assets/icons/tag-grey.svg" alt="" height="14px" class="m-r-4">
									Total {{ denda.total_denda | currency }}
								</div>
							</div>
						</div>
						<div class="loadmoreSpinner" id="loadingSpinnerListDenda" style="display: none">
							<center>
								<div class="sp sp-circle"></div>
							</center>
						</div>
					</div>

					<!-- PLUS ICON -->
					<div class="flying-button-wrapper" v-if="validateAccess('fine.create')" @click="createDenda">
						<div class="w-limit flying-inside">
							<div class="flying-button" id="drop"></div>
						</div>
					</div>

					<!-- CONTEXT MENU -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FilterSorting from "@/component-items/FilterSorting";

	export default {
		name: "ListDenda",
		components: {
			FilterSorting,
		},
		data() {
			return {
				infoDenda: {},

				listDenda: [],
				listDendaPagination: {
					limit: 20,
					offset:0,
					length: 0,
					pageNumber: 0,
					sortBy: "nama",
					orderBy: "ASC",
				},

				// search
				timer: null,
				searchDenda: "",
				listDendaSearch: [],
				listDendaSearchPagination: {
					limit: 20,
					offset:0,
					length: 0,
					pageNumber: 0,
					sortBy: "nama",
					orderBy: "ASC",
					key: "",
				},

				requestHeaders: {
					headers: {
						'Authorization': 'Bearer ' + localStorage.getItem('token'),
					}
				},
			}
		},
		mounted() {
			this.getListDenda()
			$(".showPageSearch").hide();
			$(".showSearchPageDenda").hide();
			this.scroll()

			this.backButtonPressed(this.back)
		},
		methods: {
			back(){
				this.$emit('backtolistpenggajian')
			},
			scroll() {
				window.onscroll = () => {
					if ($('#loadingSpinnerListDenda').is(":hidden")) {
						if ($(".showPageDenda").is(":visible")) {
							if (this.listDendaPagination.pageNumber <= Math.ceil(this.listDendaPagination.length / this.listDendaPagination.limit)) {
								if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
									this.listDendaPagination.offset = (this.listDendaPagination.pageNumber * this.listDendaPagination.limit);
									if (this.listDendaPagination.offset > 0) {
										this.getListDenda();
									}
									$('#loadingSpinnerListDenda').show()
								}
							}
						}
					}

					if ($('#loadingSpinnerListDendaSearch').is(":hidden")) {
						if ($(".showSearchPageDenda").is(":visible")) {
							if (this.listDendaSearchPagination.pageNumber <= Math.ceil(this.listDendaSearchPagination.length / this.listDendaSearchPagination.limit)) {
								if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
									this.listDendaSearchPagination.offset = (this.listDendaSearchPagination.pageNumber * this.listDendaSearchPagination.limit);
									this.searchDendaFunc();
									$('#loadingSpinnerListDendaSearch').show()
								}
							}
						}
					}
				}
			},
			showSearchPage() {
				$(".showPageSearch").show();
				$(".showSearchPageDenda").show()
				$(".showSearchPageDenda").addClass('animated slideInDown')
				$("#textSearchDenda").text("Minimal 2 karakter")
				$(".showPageDenda").hide();
				$("#inputSearchDenda").focus();
			},
			searchDendaKeyup() {
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
				this.timer = setTimeout(() => {
					// $(".spinner").prop("style", "display:inline-block");
					this.searchDendaFunc();
				}, 500);
			},
			async searchDendaFunc() {
				var key = this.searchDenda;
				if (this.listDendaSearchPagination.offset === 0 || this.listDendaSearchPagination.key !== key) {
					this.listDendaSearch=[];
					$("#textSearchDenda").text("Sedang mencari...")
					this.listDendaSearchPagination = {
						limit: 20,
						offset:0,
						length: 0,
						pageNumber: 0,
						sortBy: "nama",
						orderBy: "ASC",
						key: key,
					}
				}

				if (key.length >= 2) {
					try {
						const res = await this.$axios.get(this.$baseurl + "masterData/penggajian/meta/list_potongan_perkaryawan" +
							"?limit=" + this.listDendaSearchPagination.limit +
							"&offset=" + this.listDendaSearchPagination.offset +
							"&sort_by=" + this.listDendaSearchPagination.sortBy +
							"&order_by=" + this.listDendaSearchPagination.orderBy +
							"&key=" + this.listDendaSearchPagination.key
							, this.requestHeaders)
						if (res.data.status) {

							for (let i = 0; i < res.data.data.list_denda.length; i++) {
								this.listDendaSearch.push(res.data.data.list_denda[i])
							}

							this.listDendaSearchPagination.length = res.data.data.informasi_denda.total_karyawan
							this.listDendaSearchPagination.pageNumber++
							$('#loadingSpinnerListDendaSearch').hide()

							if (this.listDendaSearchPagination.length > 0){
								$("#textSearchDenda").text("Ditemukan " + this.listDendaSearchPagination.length + " data denda dengan kata '" + key + "'");

							} else {
								$("#textSearchDenda").text("Tidak menemukan '"+key+"'");
							}
						} else {
							$("#textSearchDenda").text("Tidak menemukan '"+key+"'");

							this.$toast.error(res.data.message)
							$('#loadingSpinnerListDendaSearch').hide()
						}
					} catch (e) {
						$("#textSearchDenda").text("Tidak menemukan '"+key+"'");

						this.$catch_error_response(e)
						$('#loadingPage').removeClass('overlayLoading');
						$('#loadingPage').hide()
					}
				}
			},
			closeSearchDenda() {
				this.getListDenda();
				$(".showPageSearch").hide();
				$(".showSearchPageDenda").hide();
				$(".showSearchPageDenda").removeClass('animated slideInDown');
				$(".showPageDenda").show();
				this.listDendaSearch = [];
				this.searchDenda = "";

				$("#textSearchDenda").text("Minimal 2 karakter")
				this.listDendaSearchPagination = {
					limit: 20,
					offset:0,
					length: 0,
					pageNumber: 0,
					sortBy: "nama",
					orderBy: "ASC",
					key: "",
				}
			},
			async getListDenda() {
				if (this.listDendaPagination.offset === 0) {
					$('#loadingPage').addClass('overlayLoading');
					$('#loadingPage').show()
					this.listDenda = [];
				}

				try {
					const res = await this.$axios.get(this.$baseurl + "masterData/penggajian/meta/list_potongan_perkaryawan" +
						"?limit=" + this.listDendaPagination.limit +
						"&offset=" + this.listDendaPagination.offset +
						"&sort_by=" + this.listDendaPagination.sortBy +
						"&order_by=" + this.listDendaPagination.orderBy
						, this.requestHeaders)
					if (res.data.status) {
						$('#loadingPage').removeClass('overlayLoading');
						$('#loadingPage').hide();

						this.infoDenda = res.data.data.informasi_denda;
						for (let i = 0; i < res.data.data.list_denda.length; i++) {
							this.listDenda.push(res.data.data.list_denda[i])
						}

						this.listDendaPagination.length = res.data.data.informasi_denda.total_karyawan
						this.listDendaPagination.pageNumber++
						$('#loadingSpinnerListDenda').hide()
					} else {
						$('#loadingPage').removeClass('overlayLoading');
						$('#loadingPage').hide();

						this.$toast.error(res.data.message)
						$('#loadingSpinnerListDenda').hide()
					}
				} catch (e) {
					$('#loadingPage').removeClass('overlayLoading');
					$('#loadingPage').hide();

					this.$catch_error_response(e)
					$('#loadingSpinnerListDenda').hide()
					$('#loadingPage').removeClass('overlayLoading');
					$('#loadingPage').hide()
				}
			},
			detailDenda(idkaryawan) {
				this.$emit("detailListPotongan", idkaryawan)
			},

			createDenda(){
				this.$emit('createpotomgan')
			},

			async filter(payload) {
				this.listDendaPagination = payload.data
				await this.getListDenda();
				$("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
			}
		},
	}
</script>